import { 
    FETCH_TIPOS_ADQUIRIENTES, 
    FETCH_SITUACION_IVA, 
    FETCH_TIPOS_SEXO, 
    FETCH_TIPOS_CONCEPTOS,
    LOADING_TIPOS_CONCEPTOS
} from '../actions/types';

const initialState = {
    loadingTipos: false,
    tipoSexo: [],
    adquirientes: [],
    situacionIva: [],
    tipoLiquidacionConcepto: []
}

export default function (state = initialState, action) {
    
    switch(action.type) {

        case FETCH_TIPOS_ADQUIRIENTES:
            return{
                ...state,
                adquirientes:action.payload
            };

        case FETCH_SITUACION_IVA: 
            return {
                ...state,
                situacionIva: action.payload
            };

        case FETCH_TIPOS_SEXO: 
            return {
                ...state,
                tipoSexo: action.payload
            };

        case FETCH_TIPOS_CONCEPTOS:
            return {
                ...state,
                tipoLiquidacionConcepto: action.payload
            };

        case LOADING_TIPOS_CONCEPTOS:
            return {
                ...state,
                loadingTipos: action.payload
            };

        default: return state;
    }
}